<template>
    <div style="position: relative;">
        <NavBar :index="3" />
        <!-- 轮播图 -->
        <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
        <swiper :options="swiperOption" ref="mySwiper" id="mySwiper" class="swiper-no-swiping">
            <!-- 轮播图轮播图0 -->
            <swiper-slide class="swiper_slide_item">
                <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
                    <swiper-slide>
                        <div class="one-card"
                            style=" border-radius: 0; position: relative; width: 100vw; height: 100vh;margin: 0;">
                            <video
                                src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/5e1205352fd8a7f781048f6c710cd736.mp4"
                                autoplay muted loop
                                style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                                preload="auto">
                            </video>
                            <div class="textara">
                                <div class="text-cons">应用场景</div>
                                <div class="text-fonts">汇聚智慧,技术创新,智慧谷为您打造全方位多场景解决方案,推动企业数字化转型,共同构建数字生态。
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!--分页器-->
                    <!-- <div class="top-pagination" slot="pagination"></div> -->
                </swiper>
                <!-- Tab 导航 - 使用与businessList相同的样式 -->
                <div class="top-business-tabs">
                    <div class="tab-nav">
                        <div v-for="(tab, index) in topTabs" :key="index"
                            :class="['tab-item', { active: index === 0 }]" @click="switchTopTab(index)"
                            :style="{ borderBottom: topTabActive === index ? 'none' : 'none' }">
                            {{ tab.name }}
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 1数字生态 -->
            <swiper-slide>
                <div class="st-big">
                    <div class="card-Tit" :class="activeIndex == 1 ? 'animated-title-second' : ''">"智慧谷"数字化生态平台</div>
                    <img src="../assets/szjj.png" alt="" :class="activeIndex == 1 ? 'animated-partner-row-delay1' : ''">
                </div>
            </swiper-slide>
            <!-- 2数字支付 -->
            <swiper-slide class="swiper_slide_item">
                <div class="szzf-big">
                    <div class="szzf-tit" :class="activeIndex == 2 ? 'animated-title-second' : ''">数字支付开发平台</div>
                    <div class="szzf-con">
                        <div class="sz-left" :class="activeIndex == 2 ? 'animated-title-second' : ''">
                            <img src="../assets/szkfpt.png" alt="">
                        </div>
                        <div class="sz-right" :class="activeIndex == 2 ? 'animated-partner-row-delay1' : ''">
                            <div class="sz-top">
                                <img src="../assets/ottd.png" alt="">
                                <div class="sz-pt">平台特点</div>
                            </div>
                            <div class="sz-feature-list">
                                <div class="sz-feature-item">
                                    <div class="sz-feature-item-title">多种结算类型</div>
                                    <div class="sz-feature-item-desc">使用数字资产作为结算货币，结算资产类型可根据商家需要自行选择</div>
                                </div>
                                <div class="sz-feature-item">
                                    <div class="sz-feature-item-title">交叉支付</div>
                                    <div class="sz-feature-item-desc">同时支持多种数字资产的交叉支付</div>
                                </div>
                                <div class="sz-feature-item">
                                    <div class="sz-feature-item-title">促进企业发展</div>
                                    <div class="sz-feature-item-desc">帮助企业触达数字金融、数字产业、甚至数字生态</div>
                                </div>
                                <div class="sz-feature-item">
                                    <div class="sz-feature-item-title">拓展商业模式</div>
                                    <div class="sz-feature-item-desc">依托数字支付优化场景，打通边界延伸生态，拓展多样化的商业模式</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 3数字商城 -->
            <swiper-slide>
                <div class="video-containers">
                    <video ref="video1"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2015.mp4"
                        autoplay muted style="width: 100%; height: 100%; object-fit: contain;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-overlays" :class="activeIndex == 3 ? 'animated-title-second' : ''">
                            数字商城：领跑全球的十三大融合功能区块链商城</div>
                        <p class="subtitle" :class="activeIndex == 3 ? 'animated-title-second' : ''">(网信办唯一备案)</p>
                    </div>
                </div>
            </swiper-slide>
            <!-- 4数字治理-->
            <swiper-slide class="swiper_slide_item">
                <div class="video-bigs">
                    <video ref="video2"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/4b6a779a24131d8962fce3f8d1189c0a_raw.mp4"
                        autoplay muted style="width: 100%; height: 100%; object-fit: cover;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="num-tex" :class="activeIndex == 4 ? 'animated-title-second' : ''">国鉴通</div>
                        <div class="num-font" :class="activeIndex == 4 ? 'animated-title-second' : ''">一地备案异地认证的国标鉴定
                        </div>
                        <div class="num-zcon" :class="activeIndex == 4 ? 'animated-title-second' : ''">
                            智慧谷-国鉴通实验室2016年3月建成,拥有中国古陶瓷标本逾十万份,于2018年1月,经中国检验检疫(现更名为检验检测)学会指定,国家质检总局评审通过:全国唯一拥有陶瓷类、书画类资质的第三方艺术品鉴证质量湖源评定机构,为艺术品认证,验证、盛证、备案(陶瓷类、书画类)提供服务的专业鉴证机构。
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 5数字治理 行业选项卡 -->
            <swiper-slide class="swiper_slide_item">
                <div class="hangye-big">
                    <div class="hangy-tit" :class="activeIndex == 5 ? 'animated-title-second' : ''">行业落地应用案例</div>
                    <div class="tab-hangye">
                        <div v-for="(tab, index) in developmentTabs" :key="index"
                            :class="['tab-item', { active: developmentTabActive === index }]"
                            @click="switchDevelopmentTab(index)">
                            {{ tab.name }}
                        </div>
                    </div>
                    <div v-show="developmentTabActive === 0" style="width: 100%;">
                        <!-- 内容区域1 -->
                        <div class="tab-oneon">
                            <div class="video-onen">
                                <video ref="video10"
                                    src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2016.mp4"
                                    autoplay muted style="width: 100%; height: 90%; object-fit: cover;" preload="auto">
                                </video>
                            </div>
                        </div>
                    </div>
                    <div v-show="developmentTabActive === 1" style="width: 100%;">
                        <!-- 内容区域2 -->
                        <div class="tab-twon">
                            <div class="video-onen">
                                <video ref="video20"
                                    src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2017.mp4"
                                    autoplay muted style="width: 100%; height: 100%; object-fit: cover;" preload="auto">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 6专家团队 -->
            <swiper-slide class="swiper_slide_item">
                <div class="ysp-big">
                    <div class="ysp-tit">
                        <div class="ysp-fonty" :class="activeIndex == 6 ? 'animated-title-second' : ''">艺术品溯源鉴定的价值</div>
                        <div class="ysp-fonte" :class="activeIndex == 6 ? 'animated-title-second' : ''">
                            我们的艺术品第三方鉴证备案可为客户提供以下价值</div>
                    </div>
                    <!-- 内容 -->
                    <div class="ysp-cons">
                        <div class="ysp-cant">
                            <img src="../assets/xgy.png" alt=""
                                :class="activeIndex == 6 ? 'animated-title-second' : ''">
                            <img src="../assets/xge.png" alt=""
                                :class="activeIndex == 6 ? 'animated-partner-row-delay1' : ''" style="width: 93%;">
                            <img src="../assets/xgs.png" alt=""
                                :class="activeIndex == 6 ? 'animated-title-second' : ''">
                        </div>
                        <div class="ysp-center">
                            <img src="../assets/xgyuan.png" :class="activeIndex == 6 ? 'round-ones' : ''"
                                class="center-img" />
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 7企业荣誉 -->
            <swiper-slide>
                <div class="mark-bigs">
                    <div class="mark-tit">
                        <div class="mark-text" :class="activeIndex == 7 ? 'animated-title-second' : ''">应用案例</div>
                        <div class="mark-fonts" :class="activeIndex == 7 ? 'animated-title-second' : ''">
                            建盏类、陶瓷类、书画类（附案例证书展示）</div>
                    </div>
                    <div class="tab-tc">
                        <div v-for="(tab, index) in tcList" :key="index"
                            :class="['tab-item', { active: developmentTabActives === index }]" @click="swiTC(index)">
                            {{ tab.name }}
                        </div>
                    </div>
                    <div v-show="developmentTabActives === 0" style="width: 100%;">
                        <div class="tab-contents">
                            <div class="market-images-container"
                                :class="activeIndex == 7 ? 'animated-title-second' : ''">
                                <div class="market-image-item"><img src="../assets/shl.png" alt="图1" /></div>
                                <div class="market-image-item"><img src="../assets/tcl.png" alt="图2" /></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="developmentTabActives === 1" style="width: 100%;">
                        <div class="tab-contents">
                            <div class="market-images-container"
                                :class="activeIndex == 7 ? 'animated-partner-row-delay1' : ''">
                                <div class="market-image-item"><img src="../assets/shlei.png" alt="图4" /></div>
                                <div class="market-image-item"><img src="../assets/taoc.png" alt="图5" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 8区块链技术 -->
            <swiper-slide>
                <div class="video-qyl">
                    <video ref="video3"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2018.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: cover;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-qyl" :class="activeIndex == 8 ? 'animated-title-second' : ''">
                            区块链技术解决行业现状及痛点</div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 9供应链金融信用平台解决方案 -->
            <swiper-slide>
                <div class="gyl-big">
                    <div class="gyl-Tit" :class="activeIndex == 9 ? 'animated-title-second' : ''">区块链技术解决行业现状及痛点</div>
                    <img src="../assets/gyl.png" alt="" :class="activeIndex == 9 ? 'animated-partner-row-delay1' : ''">
                </div>
            </swiper-slide>
            <!-- 10平台架构 -->
            <swiper-slide>
                <div class="jr-jg">
                    <div class="jr-Tit" :class="activeIndex == 10 ? 'animated-title-second' : ''">供应链金融平台业务架构</div>
                    <img src="../assets/jinr.png" alt=""
                        :class="activeIndex == 10 ? 'animated-partner-row-delay1' : ''">
                </div>
            </swiper-slide>
            <!-- 11产品亮点 -->
            <swiper-slide>
                <div class="video-ld">
                    <video ref="video4"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2019.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: cover;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-ld" :class="activeIndex == 11 ? 'animated-title-second' : ''">产品亮点</div>
                        <div class="tex-fonts" :class="activeIndex == 11 ? 'animated-title-second' : ''">用区块链技术助力供应链金融创新
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 12 城市的效益：激活城市平台，服务产业经济-->
            <swiper-slide>
                <div class="video-city">
                    <video ref="video5"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/1177c54b984c772faff1220e63e27050_raw.mp4"
                        autoplay muted style="width: 100%; height: 95vh; object-fit: contain;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-city" :class="activeIndex == 12 ? 'animated-title-second' : ''">
                            城市的效益：激活城市平台，服务产业经济</div>
                        <div class="tex-city" :class="activeIndex == 12 ? 'animated-title-second' : ''">
                            智慧谷通过建设“智慧城市”平台服务，以数字产业化为基础，产业数字化为目标，通过技术升级和产业升级驱动本市数字经济的发展。</div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 13 直播电商 -->
            <swiper-slide>
                <div class="zb-ds">
                    <div class="zb-tit">
                        <div class="zb-one" :class="activeIndex == 13 ? 'animated-title-second' : ''">直播电商</div>
                        <div class="zb-two" :class="activeIndex == 13 ? 'animated-title-second' : ''">
                            通过区块链技术对直播电商整个流程提供共享账本记录，营造公平公正的流量经济环境，支持通证激励的形式给予用户优质行为反馈，进一步高效实现数据流通的价值并回归到平台的贡献者们。</div>
                    </div>
                    <div class="img-bigs">
                        <div class="two-img">
                            <img src="../assets/lu.png" alt=""
                                :class="activeIndex == 13 ? 'animated-title-second' : ''">
                        </div>
                        <div class="two-imgs">
                            <img src="../assets/ren.png" alt=""
                                :class="activeIndex == 13 ? 'animated-partner-row-delay1' : ''">
                        </div>
                    </div>
                    <div class="card-san" :class="activeIndex == 13 ? 'animated-title-second' : ''">
                        <div class="card-backs">
                            <div class="font-cards">可信环境</div>
                            <div>区块链分布式账本对整个交易流程进行记账，提供更加安全的共享账本数字钱包，努力营造一个公平公正公开透明的流量经济社区环境。</div>
                        </div>
                        <div class="card-backs">
                            <div class="font-cards">通证激励</div>
                            <div>采用数字通证形式对每一位做出贡献的成员进行正向行为激励，通过观看短视频、直播，以及转发分享、点赞评论等行为领取奖励。</div>
                        </div>
                        <div class="card-backs">
                            <div class="font-cards">最终目标</div>
                            <div>让流量产生数据，让数据产生价值，最终将价值回归所有在平台辛勤耕耘的贡献者们。</div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 14 共享房车 -->
            <swiper-slide>
                <div class="gxfc-big">
                    <div class="gxfc-tit">
                        <div class="gxfc-one" :class="activeIndex == 14 ? 'animated-title-second' : ''">共享房车智慧出行应用场景
                        </div>
                        <div class="gxfc-two" :class="activeIndex == 14 ? 'animated-title-second' : ''">
                            通过区块链技术将文旅、房车、营地、民宿、一县一特等转化为链上资源，打造一站式文旅服务平台，包括文旅活动、房车租赁、文创商城等，全方位提升用户体验。</div>
                    </div>
                    <div class="gxfc-cons">
                        <div class="gxfcz" :class="activeIndex == 14 ? 'animated-title-second' : ''">
                            <img src="../assets/gxfczb.png" alt="">
                        </div>
                        <div class="gxfcy" :class="activeIndex == 14 ? 'animated-partner-row-delay1' : ''">
                            <div class="gxfc-font">
                                据行业权威数据显示，中国房车露营行业内蕴含着万亿级的市场空间。目前持续火爆的自驾游市场带动房车露营产业的高速发展，即将迎来井喷式爆发增长。而传统共享经济出现的商业模式，用户安全、数据隐私保护等问题也亟待破解，消除“伪共享”，重构新共享，区块链是切中题意的新答案。通过区块链技术打通上下游产业，同时串联起露营地+沿途自然风光+户外装备+婚庆+一县一特的完整商业形态，将是我们所期待的共享房车发展之路。
                            </div>
                            <div class="yb-fc">
                                <img src="../assets/gxfcye.png" alt=""
                                    :class="activeIndex == 14 ? 'animated-partner-row-delay1' : ''"></img>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 15校企平台，信息数字版权应用场景 -->
            <swiper-slide>
                <div class="video-scl">
                    <video ref="video6"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/5e3f4b16fc439f26915d70b52cd88583_raw.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: cover; " preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-scl" :class="activeIndex == 15 ? 'animated-title-second' : ''">
                            校企平台，信息数字版权应用场景</div>
                        <div class="tex-scl" :class="activeIndex == 15 ? 'animated-title-second' : ''">
                            全面建立学校、企业、人才间的沟通桥梁，对海量数据进行链上共享账本存储交互，为证书专利链上交易
                            提供公平公正的环境。</div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 16企链通DAPP“乡村振兴”页面 -->
            <swiper-slide>
                <div class="qlt-tit">
                    <div class="qlt-text" :class="activeIndex == 16 ? 'animated-title-second' : ''">企链通DAPP“乡村振兴”页面
                    </div>
                    <div class="liange">
                        <div class="qlt-zb" :class="activeIndex == 16 ? 'animated-title-second' : ''">
                            <img src="../assets/xjs.png" alt="">
                            <img src="../assets/xms.png" alt="">
                        </div>
                        <div class="qlt-yb" :class="activeIndex == 16 ? 'animated-partner-row-delay1' : ''">
                            <img src="../assets/xczx.png" alt="">
                        </div>
                    </div>
                </div>
            </swiper-slide>

            <!-- 17数字电商和三产的融合有利于 -->
            <swiper-slide>
                <div class="video-dians">
                    <video ref="video7"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2021.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: cover;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-dis" :class="activeIndex == 17 ? 'animated-title-second' : ''">
                            数字电商和三产的融合有利于</div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 18数字电商和三产的融合有利于 -->
            <swiper-slide>
                <div class="video-num">
                    <video ref="video8"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%2022.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: contain;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-numb" :class="activeIndex == 18 ? 'animated-title-second' : ''">
                            数字电商与农产品融合</div>
                    </div>
                </div>
            </swiper-slide>

            <!-- 19数字电商和三产的融合有利于 -->
            <swiper-slide>
                <div class="video-dsc">
                    <video ref="video9"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/169157878a503f4e9c750e60f89b5e1d_raw.mp4"
                        autoplay muted style="width: 100%; height: 100vh; object-fit: cover;" preload="auto">
                    </video>
                    <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
                        <div class="text-dsan" :class="activeIndex == 19 ? 'animated-title-second' : ''">
                            新平台|新商机</div>
                        <div class="text-scy" :class="activeIndex == 19 ? 'animated-title-second' : ''">
                            加入我们，您将享有更多服务</div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 可选的控件 -->
            <swiper-slide class="swiper_slide_item">
                <!-- 底部 -->
                <div class="card-imgs " :class="activeIndex == 8 ? 'animated-image' : ''">
                    <video
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
                        autoplay muted loop style="width: 100%; height: 100%;  object-fit: cover;" preload="auto">
                    </video>
                    <div class="gradient-con">
                        <div class="gradient-text ">链上生态互融 共享数字未来</div>
                        <div class="gradient-p">智慧谷-您的企业数改服务商</div>
                    </div>
                </div>
                <div class="footer" :class="activeIndex == 8 ? 'animated-image' : ''">
                    <div class="footer_top">
                        <!-- 左 -->
                        <div class="footerTopLeft">
                            <!-- 1 -->
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumps(0)">走进智慧谷</h4>
                                <p @click="jumps(1)">集团介绍</p>
                                <p @click="jumps(5)">发展历程</p>
                                <p @click="jumps(7)">企业荣誉</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumphx(0)">核心业务</h4>
                                <p @click="jumphx(5)">CHAIN企业链改服务</p>
                                <p @click="jumphx(8)">企链通DAPP数商平台</p>
                                <p @click="jumphx(11)">智慧谷AI名片</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumpcj(0)">应用场景</h4>
                                <p @click="jumpcj(2)">数字支付</p>
                                <p @click="jumpcj(3)">数字商城</p>
                                <p @click="jumpcj(19)">数字三农</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumpgh(0)">合作规划</h4>
                                <p @click="jumpgh(1)">合作流程</p>
                                <p @click="jumpgh(2)">合作收益</p>
                                <p @click="jumpgh(4)">全球战略</p>
                            </div>
                        </div>
                        <!-- 右 -->
                        <div class="footerTopRight">
                            <!-- 1 -->
                            <!-- <div class="RightCon" style="font-size: 20px;">
						<p style="cursor: pointer;">联系我们</p>
					</div> -->
                            <div class="RightCon">
                                <img src="../assets/tel.png" mode=""></img>
                                <p>电话：400-8537-168</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/web.png" mode=""></img>
                                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/email.png" mode=""></img>
                                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/dz.png" mode=""></img>
                                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
                            </div>
                            <!-- code -->
                            <div class="code">
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/gzh.jpg" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                                </div>
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/kf.png" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer_botm">
                        <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">闽ICP备16005520号-1</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
                        <p style="text-indent:1em;">|</p>
                        <p style="text-indent:1em;"> Powered by CloudDream </p>
                    </div>
                </div>
            </swiper-slide>
            <!--分页器-->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import NavBar from '../components/NavBar.vue';
export default {
    components: {
        NavBar
    },
    name: "FullPage",
    data() {
        return {
            developmentTabActive: 0,
            developmentTabActives: 0, //陶瓷
            businessActive: 0,
            activeIndex: 0,
            newsData: [],//循环新闻
            topTabActive: 0,//轮播图上的tab
            topTabs: [
                { name: '数字生态' },
                { name: '数字支付' },
                { name: '数字商城' },
                { name: '数字治理' },
                { name: '数字金融' },
                { name: '数字城市' },
                { name: '数字直播' },
                { name: '数字文旅' },
                { name: '数字版权' },
                { name: '数字三农' },
            ],
            currentTab: 'first',
            currentModule: 0, // 当前显示的模块索引
            isExpanded: false, // 是否展开查看全部
            expandedItem: -1,
            cardPageIndex: 0,
            developmentTabs: [
                { name: '六位一体的艺术品鉴定体系' },
                { name: '三鼎构建数权信用系统' },
            ],

            tcList: [
                { name: '书画类' },
                { name: '陶瓷类' },
            ],
            isStrategyExpanded: false, // 是否展开显示全部内容
            selectedStrategy: -1, // 当前选中的战略项目
            honorActiveTab: 'certification', // 企业荣誉选项卡激活状态
            // 市场认可轮播相关数据
            marketCurrentSlide: 0, // 当前轮播页
            marketTotalSlides: 3, // 总轮播页数
            swiperbotomInex: 0,
            // swiper 配置
            swiperOption: {
                direction: "vertical", // swiper 方向
                mousewheel: true,
                // 分页器
                pagination: {
                    el: ".swiper-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 记录当前页index
                        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
                        console.log(this.activeIndex, ' this.activeIndex')
                    },
                }
            },
            // 顶部
            swiperTop: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                // autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".top-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                            this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
                        }
                    },
                }
            },
            swiperTwo: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                loop: true,
                // autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".two-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                            this.cardPageIndex = this.$refs.swiperTwo.$swiper.activeIndex;
                        }
                    },
                }
            },


            // 市场认可
            swiperbotom: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                loop: true,
                autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".swiperbotom", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                            this.swiperbotomInex = this.$refs.swiperbotom.$swiper.swiperbotomInex;
                        }
                    },
                }
            },
            //企业核心
            swiperTopbot: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".top-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                            this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
                        }
                    },
                }
            },
        };
    },
    mounted() {
        // 初始化定时器，开始监听
        let that = this
        if (that.$route.query.num && that.$route.query.num != 0) {
            this.topTabActive = that.$route.query.num * 1;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                console.log((that.$route.query.num * 1) + 1);
            }
        } else {
            this.topTabActive = 0;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo(0);
            }
        }

    },

    watch: {
        // 监听 businessActive 变量的变化
        businessActive(newVal, oldVal) {
            // 每次 businessActive 变化时，重置15秒的计时器
            clearTimeout(this.timeoutId);
            // this.resetTimeout();

        },
        // 视频切换一直播放
        activeIndex(newVal, oldVal) {
            // 3数字商城
            if (newVal == 3) {
                let video = this.$refs.video1;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 4数字治理
            if (newVal == 4) {
                let video = this.$refs.video2;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 8区块链技术
            if (newVal == 8) {
                let video = this.$refs.video3;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }

            // 11产品亮点
            if (newVal == 11) {
                let video = this.$refs.video4;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 12 城市的效益：激活城市平台，服务产业经济
            if (newVal == 12) {
                let video = this.$refs.video5;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }

            // 15校企平台，信息数字版权应用场景
            if (newVal == 15) {
                let video = this.$refs.video6;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }

            // 17数字电商和三产的融合有利于
            if (newVal == 17) {
                let video = this.$refs.video7;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }

            // 18数字电商和三产的融合有利于
            if (newVal == 18) {
                let video = this.$refs.video8;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }

            //19数字电商和三产的融合有利于
            if (newVal == 19) {
                let video = this.$refs.video9;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 5选项卡数字电商和三产的融合有利于
            if (newVal == 5 && this.developmentTabActive === 0) {
                let video = this.$refs.video10;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            if (newVal == 5 && this.developmentTabActive === 1) {
                let video = this.$refs.video20;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
        },
        '$route.query.num': function (newNum) {
            // 这里是num变化时执行的操作
            let that = this
            if (that.$route.query.num != 0) {
                console.log('num changed:', newNum);
                this.topTabActive = that.$route.query.num * 1;
                console.log(that.$route.query.num)
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                    console.log((that.$route.query.num * 1) + 1);
                }
            } else {
                console.log('num chassssnged:', newNum);

                this.topTabActive = 0;
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo(0);
                }
            }
        }
    },
    methods: {
        // 切换发展选项卡行业选项卡
        switchDevelopmentTab(index) {
            this.developmentTabActive = index;
        },

        swiTC(index) {
            this.developmentTabActives = index;
        },
        // 切换模块  第一篇和第二篇
        switchModule(index) {
            this.currentModule = index;
            this.isExpanded = false; // 切换模块时收起详细内容
        },
        // 切换查看全部状态
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        },
        // 切换展开/收起状态
        toggleExpand(index) {
            this.expandedItem = this.expandedItem === index ? null : index;
            console.log('切换展开状态:', index, this.expandedItem);
        },
        // 选择战略项目
        selectStrategy(index) {
            if (!this.isStrategyExpanded) {
                this.selectedStrategy = this.selectedStrategy === index ? -1 : index;
            }
        },
        switchTab(index) {
            this.businessActive = index;
            this.pageIndex = index;
            // 清除定时器，重置 15 秒的计时
            clearTimeout(this.timeoutId);
            // 重启15秒监控
            // this.resetTimeout();

            // 如果有正在进行的定时器，清除并重新启动自动切换定时器
            clearInterval(this.intervalId);
        },

        // 轮播图的tab
        switchTopTab(index) {
            console.log(index);
            this.topTabActive = index;
            if (index == 9) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(16);
                }
            } else if (index == 8) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(7);
                }
            }  else if (index == 7) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(14);
                }
            }  else if (index == 6) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(13);
                }
            } else if (index == 5) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(12);
                }
            } else if (index == 4) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(8);
                }
            }  else if (index == 3) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(4);
                }
            }  else if (index == 2) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(3);
                }
            } else if (index == 1) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(2);
                }
            } 
            else if (index == 0) {
                // 同步轮播图
                if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                    this.$refs.mySwiper.$swiper.slideTo(1);
                }
            } 
        },


        topOne() {
            this.$refs.mySwiper.$swiper.slideTo(0);
            this.activeIndex = 0
        },
        // ... 第一篇 第二篇
        switchContentTab(tab) {
            this.currentTab = tab;
            // 可以根据不同tab切换不同的contentItems数据
        },
        // 切换企业荣誉选项卡
        switchHonorTab(tab) {
            this.honorActiveTab = tab;
        },
        // 市场认可轮播控制方法
        nextMarketSlide() {
            // 切换swiperTop到下一页
            if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                this.$refs.swiperbotom.$swiper.slideNext();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.swiperbotomInex < 1) {
                this.swiperbotomInex++;
            } else {
                this.swiperbotomInex = 0;
            }
            console.log('下一页，当前页:', this.swiperbotomInex);
        },
        prevMarketSlide() {
            if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                this.$refs.swiperbotom.$swiper.slidePrev();
            }
            // 如需同步swiperbotomInex变量，可保留如下逻辑
            if (this.swiperbotomInex > 0) {
                this.swiperbotomInex--;
            } else {
                this.swiperbotomInex = 1;
            }
            console.log('上一页，当前页:', this.swiperbotomInex);
        },
        goToMarketSlide(index) {
            this.marketCurrentSlide = index;
            console.log('跳转到页面:', index);
        },

        // 5个
        jumps(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
        },

        jumphx(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
        },

        jumpcj(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
        },
        jumpgh(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
        },
        // 跳转智慧码
        jumpZh() {
            window.location.href = 'https://web-aggregation.gjwec.com'
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },
        //事件
        lookAll(index) {
            this.secondData[index].showAll = !this.secondData[index].showAll;
        },
        // 第二块
        lookAlltwoData(index) {
            this.twoData[index].showAlltwoData = !this.twoData[index].showAlltwoData;
        },
        // 第三块
        lookAlltreen(index) {
            this.treen[index].showAlltreen = !this.treen[index].showAlltreen;
        },
        // 第四块
        lookAllfours(index) {
            this.fours[index].showAllfours = !this.fours[index].showAllfours;
        },
        nextCardPage() {
            // 切换swiperTop到下一页
            if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                this.$refs.swiperTwo.$swiper.slideNext();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.cardPageIndex < 1) {
                this.cardPageIndex++;
            } else {
                this.cardPageIndex = 0;
            }
            console.log('下一页，当前页:', this.cardPageIndex);
        },
        prevCardPage() {
            // 切换swiperTop到上一页
            if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                this.$refs.swiperTwo.$swiper.slidePrev();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.cardPageIndex > 0) {
                this.cardPageIndex--;
            } else {
                this.cardPageIndex = 1;
            }
            console.log('上一页，当前页:', this.cardPageIndex);
        },
    },
};
</script>

<style scoped>
/* 上排证书从左向右动画 - 居中对齐 */
.animated-partner-row-delay1 {
    animation: slideInFromRight 0.8s ease-out forwards;
}

.animated-image {
    animation: slideInFromRight 0.8s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-cert-left {
    animation: slideInFromLeftCert 1.5s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

.animated-partner-row {
    animation: slideInFromLeft 0.8s ease-out forwards;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}


* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 顶部轮播图tab导航样式 - 与business-tabs保持一致 */
.top-business-tabs {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    width: 100%;
    max-width: 1500px;
    display: flex;
    justify-content: center;
}

.top-business-tabs .tab-nav {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 50px;
}

.top-business-tabs .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #2c3e50;
}

.top-business-tabs .tab-item:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #333;
}

.top-business-tabs .tab-item.active {
    background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
    color: #2D7CFE;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    border-radius: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-business-tabs {
        bottom: 80px;
        padding: 0 20px;
    }

    .top-business-tabs .tab-nav {
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px;
    }

    .top-business-tabs .tab-item {
        font-size: 14px;
        padding: 8px 15px;
    }
}

@media (max-width: 480px) {
    .top-business-tabs .tab-nav {
        gap: 5px;
        padding: 8px;
    }

    .top-business-tabs .tab-item {
        font-size: 12px;
        padding: 6px 12px;
    }

    .strategy-container {
        padding: 0 10px;
    }

    .strategy-row {
        gap: 10px;
    }

    .strategy-item {
        min-height: 220px;
    }

    .strategy-item.expanded {
        min-height: 300px;
    }

    .strategy-icon {
        width: 50px;
        height: 50px;
    }

    .strategy-icon img {
        width: 30px;
        height: 30px;
    }

    .strategy-title {
        font-size: 14px;

    }

    .strategy-subtitle {
        font-size: 10px;
    }

    .strategy-content {
        font-size: 11px;
        padding: 5px;
        min-height: 60px;
    }

    .expand-icon {
        bottom: 5px;
    }

    .expand-icon img {
        width: 20px;
        height: 20px;
    }
}

/* 顶部按钮*/
.top-nav {
    width: 40px;
    height: 40px;
    position: fixed;
    right: 0em;
    bottom: 650px;
    z-index: 1000;
    cursor: pointer;
    transition: all 0.3s ease;
}

.top-nav:hover {
    transform: scale(1.1);
}

#mySwiper {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.swiper-pagination {
    right: 1em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
    --swiper-pagination-color: #fff;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

#swiperTwo {
    height: 600px;
    --swiper-pagination-color: #2D7CFE;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.swiper-pagination-bullet-active {
    background-color: #0000ff;
    /* 选中的小圆点颜色为蓝色 */
}

.top-pagination,
.two-pagination,
.swiperbotom {
    position: absolute;
    width: 100%;
    justify-content: center;
    bottom: 10px;
    display: flex !important;
    z-index: 15;
}

.top-pagination .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s;
}

.two-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #555;
    /* 未选中时为灰色 */
    opacity: 1;
    transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

.two-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

/* 生态系统 */
.st-big {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url('../assets/zhgst.png');
    background-size: cover;
    /* 背景图占满 */
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
    position: relative;
}

.st-big .card-Tit {
    position: absolute;
    top: 50px;
    text-align: center;
    width: 100%;
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    z-index: 1;
}

.st-big img {
    width: 70%;
    height: auto;
    object-fit: contain;
    margin-top: 180px;
}


/* 第一个轮播图视频 */
.textara {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    flex-direction: column;
    color: #fff;
    width: 100%;
    top: 280px;
    left: 200px;
}

.text-cons {
    font-size: 65px;
    padding-bottom: 15px;
    margin-top: 80px;
}

.text-fonts {
    width: 700px;
    /* border: 1px solid; */
    font-size: 20px;
    margin-right: 30px;
    line-height: 40px;
}

.one-card,
.two-card {
    width: 300px;
    border-radius: 20px;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    /* 使用弹性布局 */
    flex-direction: column;
}

.one-card .card-header,
.two-card .card-header {
    border-radius: 10px 10px 0 0;
    flex-shrink: 0;
}

.one-card .card-content,
.two-card .card-content {
    flex: 1;
    /* 内容区域占据剩余空间 */
    border: 1px solid #2D7CFE;
    border-top: none;
}

/* Responsiveness */
@media (max-width: 768px) {
    .cardTwo {
        flex-direction: column;
    }

    .left-button,
    .right-button {
        left: 0;
        right: 0;
        top: auto;
        transform: none;
    }

    .one-card,
    .two-card {
        width: 100%;
        margin-bottom: 20px;
    }
}

/* 视频容器样式优化 */
.video-center {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.video-center video {
    width: 80vw;
    height: 70vh;
    object-fit: cover;
    margin-top: 140px;
}

.video-center>div {
    position: absolute;
    top: -34%;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    text-align: center;
}

.text-over {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.subtit {
    color: #A7A9AC;
    font-size: 18px;
    text-align: center;
}

/* 艺术品溯源鉴定的价值 */
.ysp-big {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../assets/yspbig.png');
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.ysp-tit {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 100px;
}

.ysp-fonty {
    font-size: 28px;
    font-weight: 600;
    color: #000;
    padding-bottom: 10px;
}

.ysp-fonte {
    color: #A7A9AC;
    font-size: 17px;
}


.ysp-cons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    position: relative;
    /* 为了让中间的圆球脱离文档流 */
    margin-top: 100px;
}

.ysp-cant {
    width: 80%;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* flex-wrap: wrap; */
    gap: 10px;
    flex-direction: column;
    margin-left: 10%;
    margin-top: 120px;
}

.ysp-cant img {
    width: 80%;
    height: 300px;

}

.ysp-center {
    position: absolute;
    /* 脱离文档流 */
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* 居中对齐 */
    z-index: 1;
}

.center-img {
    width: 450px;
    height: auto;
}


/* 中间球 */
.round-ones {
    animation: roundGrow 0.8s ease-out forwards;
}

@keyframes roundGrow {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

.fade-in-1 {
    animation-name: fadeInImage;
    animation-delay: 0.2s;
    animation-play-state: running;
}

.fade-in-2 {
    animation-name: fadeInImage;
    animation-delay: 0.6s;
    animation-play-state: running;
}

.fade-in-3 {
    animation-name: fadeInImage;
    animation-delay: 1s;
    animation-play-state: running;
}

.fade-in-4 {
    animation-name: fadeInImage;
    animation-delay: 1.4s;
    animation-play-state: running;
}

@keyframes fadeInImage {
    from {
        opacity: 0;
        transform: scale(0.5);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}


.fade-in-1 {
    animation-name: fadeInImage;
    animation-delay: 0.2s;
    animation-play-state: running;
}

.fade-in-2 {
    animation-name: fadeInImage;
    animation-delay: 0.6s;
    animation-play-state: running;
}

.fade-in-3 {
    animation-name: fadeInImage;
    animation-delay: 1s;
    animation-play-state: running;
}

.fade-in-4 {
    animation-name: fadeInImage;
    animation-delay: 1.4s;
    animation-play-state: running;
}

@keyframes fadeInImage {
    from {
        opacity: 0;
        transform: scale(0.5);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* 底部导航栏 */
.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}

.card-img .vjs-custom-skin {
    width: 100%;
    max-width: 580px;
    height: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid red;
}

.card-img .vjs-custom-skin video {
    object-fit: cover;
}

.animated-image {
    animation: slideInFromRight 1s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

.item-contan-large {
    width: 100%;
    height: 540px;
    /* 两个普通卡片的高度加上间距 */
    border: 1px dashed #0cd5fd;
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, #E2F3FC 100%);
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5em;
}

.item-contan-large ul li {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
}

.item-contan-large ul li::marker {
    color: #2D7CFE;
    /* 蓝色圆圈 */
}

.item-contan:first-of-type ul li::marker {
    color: #0cd5fd;
}


/* 响应式设计 */
@media (max-width: 1200px) {
    .expert-container {
        width: 95%;
    }
}

@media (max-width: 768px) {
    .expert-container {
        flex-direction: column;
        width: 100%;
        gap: 15px;
    }

    .left-experts {
        flex: none;
    }

    .expert-row {
        flex-direction: column;
        gap: 15px;
    }

    .expert-row .item-contan {
        width: 100%;
    }

    .right-expert {
        flex: none;
    }

    .item-contan-large {
        height: 260px;
        /* 在小屏幕上使用正常高度 */
    }
}


/* 3333333333333333第一篇、第二篇  */
.one-card {
    width: 100%;
    height: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    padding-top: 50px;
}

.gradient-btn {
    width: 280px;
    margin-top: 50px;
    height: 60px;
    padding: 10px 30px;
    border: none;
    border-radius: 50px;
    background: linear-gradient(90deg, #2821FE 0%, #00D4FF 100%);
    color: white;
    font-size: 28px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.gradient-btn:hover {
    transform: scale(1.05);
}

/* 业务内容区域样式 */
.business-content-section {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

/* Tab导航样式 */
.tab-navs {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 20px;
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #E5E5E5;
}

.tab-item {
    padding: 15px 0;
    cursor: pointer;
    border-radius: 0;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #9EAAC1;
    font-weight: 400;
    position: relative;
    background: transparent;
    border-bottom: 2px solid transparent;
}

.tab-item:hover {
    color: #2D7CFE;
}

/* 标题动画 - 从左侧滑入居中 */
.card-Tit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.card-con {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 22px;
    color: #A7A9AC;
}

.animated-title {
    animation: slideInFromLeft 2s ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}



.animated-title {
    animation: slideInFromLeft 2s ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-title-second {
    animation: slideInFromLeft 0.8s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
    animation: slideInFromRightRow 2.5s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRightRow {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 数字支付开发平台 */
.st-big {
    width: 100%;
    /* border: 1px solid; */
}

.szzf-tit {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #000;
    margin-top: 100px;
    font-weight: 600;
}

.szzf-con {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 120px;
    padding-bottom: 40px;
    box-sizing: border-box;
    gap: 48px;
    /* 控制左右间距 */
    /* border: 1px solid; */
}

.sz-left,
.sz-right {
    width: 480px;
    min-width: 420px;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sz-left img {
    width: 450px;
    height: 450px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

.sz-right {
    align-items: flex-start;
    border: none;
}

.sz-top {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    margin-left: 50px;
}

.sz-top img {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.sz-pt {
    font-size: 24px;
    font-weight: bold;
    color: #2D7CFE;
}

.sz-feature-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-left: 50px;
}

.sz-feature-item {
    width: 500px;
    background: linear-gradient(91deg, #F2F6FB 0%, #E8ECFB 53%, #D8EDFC 100%);
    border-radius: 16px;
    padding: 18px 28px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(45, 124, 254, 0.06);
}

.sz-feature-item-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 6px;
}

.sz-feature-item-desc {
    font-size: 15px;
    color: #6B7A90;
    line-height: 1.7;
}


/* 数字商城：领跑全球的十三大融合功能区块链商城 */
.video-containers {
    position: relative;
    height: 100%;
    overflow: hidden;
    /* padding-top: 10px; */
    background-color: #F9FAFB;
}

.text-overlays {
    position: absolute;
    top: 100px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
}

.subtitle {
    position: absolute;
    top: 150px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #A7A9AC;
    font-size: 20px;
}

/* 数字商城 */
.video-bigs {
    position: relative;
    height: 100%;
    overflow: hidden;
}

.num-tex {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
}

.num-font {
    position: absolute;
    top: 140px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #A7A9AC;
    font-size: 15px;
}

.num-zcon {
    text-indent: 2em;
    width: 80%;
    position: absolute;
    top: 220px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #606972;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 动画效果 */
.animated-cert-left {
    animation: slideInFromLeftCert 1.5s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

.animated-bottom-row {
    animation: slideInFromLeftCert 1.5s ease-out 0.3s forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 响应式设计 - 移动端优化 */
@media (max-width: 768px) {
    .strategy-content {
        font-size: 12px;
        line-height: 1.4;
        padding: 8px 0;
        min-height: 60px;
        /* 移动端较小的最小高度 */
    }

    .strategy-content p {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .strategy-content {
        font-size: 11px;
        line-height: 1.3;
        padding: 6px 0;
        min-height: 50px;
        /* 小屏幕更小的最小高度 */
    }

    .strategy-content p {
        font-size: 11px;
    }
}

/* 发展选项卡样式 */
.hangye-big {
    width: 100%;
    background-color: #F9FAFB;
    height: 100%;
}

/* 标题 */
.hangy-tit {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    font-size: 28px;
    color: #000;
    padding-top: 100px;
    font-weight: 600;
    z-index: 9999;
    position: relative;
}

/* 两个标题 */
.tab-hangye {
    display: flex;
    /* margin-bottom: 20px; */
    justify-content: center;
    /* 居中对齐 */
    align-items: center;
    padding-top: 30px;
    gap: 30px;
}

.tab-item {
    padding: 10px 20px;
    cursor: pointer;
    text-align: center;
    color: #ccc;
    border-bottom: 2px solid transparent;
    position: relative;
    z-index: 9999;
}

.tab-item.active {
    color: #2D7CFE;
    border-bottom: 2px solid #2D7CFE;
}

.tab-content {
    padding: 20px;
    border-radius: 5px;
    background-color: #f9f9f9;
    text-align: center;
}

/* 行业选项第一个内容区域 */
.tab-oneon {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: #F9FAFB;

}

.video-onen {
    position: absolute;
    height: 100%;
    top: 80px;
}

.tab-twon {
    display: flex;
    justify-content: center;
    width: 100%;
}


/* 市场认可轮播容器样式 */
.mark-bigs {
    background-image: url('../assets/yyal.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.mark-tit {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 100px;
}

.mark-text {
    font-size: 28px;
    font-weight: 600;
    color: #000;
    padding-bottom: 10px;
}

.mark-fonts {
    color: #A7A9AC;
    font-size: 18px;
}

.tab-tc {
    display: flex;
    /* margin-bottom: 20px; */
    justify-content: center;
    /* 居中对齐 */
    align-items: center;
    padding-top: 30px;
    gap: 30px;
}

.tab-item {
    padding: 10px 20px;
    cursor: pointer;
    text-align: center;
    color: #ccc;
    border-bottom: 2px solid transparent;
    position: relative;
    z-index: 9999;
}

.tab-item.active {
    color: #2D7CFE;
    /* border-bottom: 2px solid #2D7CFE; */
}

.tab-contents {
    padding: 20px;
    border-radius: 5px;
    /* background-color: #f9f9f9; */
    text-align: center;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10%;
    margin-top: 60px;
}


/* 市场认可图片容器样式 */
.market-images-container {
    /* flex-wrap: nowrap; */
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 560px;
}

.market-image-item {
    width: 700px;
    display: flex;
    align-items: center;
    justify-content: center;
}


.market-image-item img {
    width: 100%;
    height: 650px;
    border-radius: 10px;
    transition: all 0.3s ease;
}


/* 轮播指示器样式 */
.market-carousel-indicators {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
}

.indicator-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ccc;
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator-dot:hover {
    background-color: #2D7CFE;
}

.indicator-dot.active {
    /* width: 24px; */
    border-radius: 4px;
    background-color: #2D7CFE;

}

/* 企业链技术 */
.video-qyl {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-qyl {
    position: absolute;
    top: 100px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

/* 市场认可样式# */
.gyl-big {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.gyl-big .gyl-Tit {
    position: absolute;
    top: 100px;
    text-align: center;
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    z-index: 1;
}

.gyl-big img {
    width: 80%;
    height: auto;
    object-fit: contain;
    margin-top: 130px;
}


/*10 金融 */
.jr-jg {
    background-image: url('../assets/jrfw.png');
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-size: cover;
    /* 背景图占满 */
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
    /* position: relative; */
}

.jr-jg .jr-Tit {
    position: absolute;
    top: 100px;
    text-align: center;
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    z-index: 1;
    height: 300px;
}

.jr-jg img {
    width: 100%;
    height: 80%;
    object-fit: contain;
    margin-top: 130px;
}

/* 产品亮点 */
.video-ld {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-ld {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

.tex-fonts {
    font-size: 18px;
    color: #A7A9AC;
    position: absolute;
    top: 150px;
    z-index: 999;
}

/* 城市 */
.video-city {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-city {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

.tex-city {
    font-size: 18px;
    color: #A7A9AC;
    position: absolute;
    top: 150px;
    z-index: 999;
}

/* 直播 */
.zb-ds {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 100px;
}

.zb-tit {
    text-align: center;
    margin-bottom: 20px;
}

.zb-one {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
}

.zb-two {
    font-size: 16px;
    color: #666;
    line-height: 1.5;
}

.img-bigs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    margin-top: 30px;

}

.two-img {
    display: flex;
    /* border: 1px solid; */
    width: 50%;
    align-items: center;
    height: 500px;
    justify-content: center;
    margin-left: 300px;
}

.two-img img {
    width: 1000px;
    height: 550px;
}

.two-imgs {
    display: flex;
    /* border: 1px solid; */
    width: 400px;
    align-items: center;
    height: 600px;
}

.two-imgs img {
    width: 70%;
    height: 80%;
}

/* 三张卡片 */
.card-san {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 10px;
    gap: 40px;
}

.card-backs {
    background: linear-gradient(180deg, #2D7CFE 0%, #46FDFD 100%);
    width: 23%;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    color: #fff;
    height: 160px;

}

.font-cards {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}


/* 共享房车 */
.gxfc-big {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-image: url('../assets/gxfc.png');
    /* padding-top: 100px; */
    background-repeat: no-repeat;
    /* background-size: 100% 100% ; */
    height: 100%;
    background-size: cover;
}

.gxfc-tit {
    text-align: center;
    margin-bottom: 20px;
    padding-top: 100px;
}

.gxfc-one {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
}

.gxfc-two {
    font-size: 16px;
    color: #000;
    line-height: 1.5;
}

/* tupian */
.gxfc-cons {
    width: 80%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 100px;
}

.gxfcz {
    width: 50%;
    display: flex;
    justify-content: center;
    /* 水平居中 */
}

.gxfcz img {
    width: 90%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
}

.gxfcy {
    display: flex;
    background-image: url('../assets/gxfcyb.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 650px;
    height: 600px;
    position: relative;
}

.gxfc-font {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 50px;
    color: #fff;
    font-size: 17px;
    text-align: left;
    width: 100%;
    z-index: 2;
    line-height: 3;

}

.yb-fc {
    position: absolute;
    right: 10px;
    top: 90%;
    transform: translateY(-50%);
}

.yb-fc img {
    width: 200px;
    height: 200px;
    object-fit: contain;
}


/* 校企 */
.video-scl {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-scl {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

.tex-scl {
    font-size: 18px;
    color: #A7A9AC;
    position: absolute;
    top: 150px;
    z-index: 999;
}


/* 17 */
.qlt-tit {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 100px;
}

.qlt-text {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
}

.liange {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 140px;
    width: 80%;
    gap: 100px;
}

.qlt-zb {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 80px;
    width: 620px;
    /* border: 1px solid; */
}

.qlt-zb img {
    width: 600px;
    height: auto;
    margin-bottom: 0;
}

.qlt-yb {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.qlt-yb img {
    width: 600px;
    height: auto;
}

/* 电商 17*/
.video-dians {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-dis {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}



/* 18 */
.video-num {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-numb {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

/*19 */
.video-dsc {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #F9FAFB;
}

.text-dsan {
    position: absolute;
    top: 100px;
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
    z-index: 999;
}

.text-scy {
    font-size: 18px;
    color: #A7A9AC;
    position: absolute;
    top: 150px;
    z-index: 999;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

.RightCon p {
    color: #989898;
    cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}



.footerMidd {
    width: 70%;
    height: 75%;
    border-bottom: 1px solid #cacaca;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.codes {
    width: 23%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.codes img {
    width: 100%;
    height: 100%;
}

.code h5 {
    margin-top: 10px;
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;

}


/* 图片动画 - 从右往左居中 */
.card-imgs {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    object-fit: fill;
    position: relative;
}

.vjs-custom-skin {
    width: 100%;
    height: 100%;
}

.video-js {
    width: 100% !important;
    height: 100% !important;
    min-height: 300px;
}

.video-js video {
    object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
    .card-imgs {
        max-width: 100%;
        margin-right: 0;
    }

    .card-imgs .video-js {
        min-height: 250px;
    }
}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/core.vue